import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import UserReportListPage from "../../components/UserReport/NewUserReportListPage";

const UserReportList = () => {
    return (
        <>
            <MasterLayout>
                <Breadcrumb title="User Report" />
                <UserReportListPage />
            </MasterLayout>
        </>
    );
};

export default UserReportList;
